import React from 'react';
const Option = props => {
    return React.createElement("option", Object.assign({}, props), props.children);
};
Option.propTypes = {};
Option.defaultProps = {};
export default Option;
//# sourceMappingURL=OptionV2.js.map